var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_1168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.034 6.71234C21.7894 5.76137 21.0837 5.0167 20.1791 4.76235C18.9639 4.2692 7.19445 4.02757 3.78027 4.77648C2.87565 5.03365 2.16727 5.7755 1.92532 6.72647C1.37691 9.25581 1.33524 14.7243 1.93877 17.3101C2.1834 18.2611 2.88909 19.0058 3.79371 19.2601C6.19977 19.8423 17.6386 19.9243 20.1925 19.2601C21.0971 19.003 21.8055 18.2611 22.0475 17.3101C22.6322 14.5547 22.6738 9.42538 22.034 6.71234Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4476 12.0111L9.96338 8.70459V15.3176L15.4476 12.0111Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_1168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.a4b71765f5de0e16aaaa8233e7680fa5.svg";
export { ForwardRef as ReactComponent };